{
  "insightId": "IT4BoTWzOBNB",
  "kind": 1,
  "computationKind": 3,
  "dxObject": { "id": "YYSKl3746SKD", "version": "1663005630587", "supportedDxObjectType": 1 },
  "computedAt": "2022-09-12T18:00:32.618745689Z",
  "computationHash": "testComputationHash",
  "start": "2022-08-15T04:00:00Z",
  "end": "2022-09-12T04:00:00Z",
  "createdAt": "2022-09-12T18:00:32.675347Z",
  "updatedAt": "2022-09-12T18:00:32.675347Z",
  "trend": {
    "data": {
      "metricsDataTable": {
        "table": [
          {
            "startTime": "2022-08-14T04:00:00Z",
            "endTime": "2022-08-15T04:00:00Z",
            "groups": [],
            "value": 1132.2857142857142,
            "isPartialPeriod": true
          },
          {
            "startTime": "2022-08-15T04:00:00Z",
            "endTime": "2022-08-16T04:00:00Z",
            "groups": [],
            "value": 490.3225806451613,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-16T04:00:00Z",
            "endTime": "2022-08-17T04:00:00Z",
            "groups": [],
            "value": 664.125,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-17T04:00:00Z",
            "endTime": "2022-08-18T04:00:00Z",
            "groups": [],
            "value": 621.3461538461538,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-18T04:00:00Z",
            "endTime": "2022-08-19T04:00:00Z",
            "groups": [],
            "value": 1291.090909090909,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-19T04:00:00Z",
            "endTime": "2022-08-20T04:00:00Z",
            "groups": [],
            "value": 597.2857142857143,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-20T04:00:00Z",
            "endTime": "2022-08-21T04:00:00Z",
            "groups": [],
            "value": "Infinity",
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-21T04:00:00Z",
            "endTime": "2022-08-22T04:00:00Z",
            "groups": [],
            "value": 2817.3333333333335,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-22T04:00:00Z",
            "endTime": "2022-08-23T04:00:00Z",
            "groups": [],
            "value": 632.56,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-23T04:00:00Z",
            "endTime": "2022-08-24T04:00:00Z",
            "groups": [],
            "value": 491.09090909090907,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-24T04:00:00Z",
            "endTime": "2022-08-25T04:00:00Z",
            "groups": [],
            "value": 450.8611111111111,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-25T04:00:00Z",
            "endTime": "2022-08-26T04:00:00Z",
            "groups": [],
            "value": 465.5,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-26T04:00:00Z",
            "endTime": "2022-08-27T04:00:00Z",
            "groups": [],
            "value": 339.10526315789474,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-27T04:00:00Z",
            "endTime": "2022-08-28T04:00:00Z",
            "groups": [],
            "value": 2145,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-28T04:00:00Z",
            "endTime": "2022-08-29T04:00:00Z",
            "groups": [],
            "value": 1676,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-29T04:00:00Z",
            "endTime": "2022-08-30T04:00:00Z",
            "groups": [],
            "value": 305.4727272727273,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-30T04:00:00Z",
            "endTime": "2022-08-31T04:00:00Z",
            "groups": [],
            "value": 304.94642857142856,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-08-31T04:00:00Z",
            "endTime": "2022-09-01T04:00:00Z",
            "groups": [],
            "value": 257.28125,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-01T04:00:00Z",
            "endTime": "2022-09-02T04:00:00Z",
            "groups": [],
            "value": 258.39344262295083,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-02T04:00:00Z",
            "endTime": "2022-09-03T04:00:00Z",
            "groups": [],
            "value": 278.04651162790697,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-03T04:00:00Z",
            "endTime": "2022-09-04T04:00:00Z",
            "groups": [],
            "value": 1366,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-04T04:00:00Z",
            "endTime": "2022-09-05T04:00:00Z",
            "groups": [],
            "value": 1699,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-05T04:00:00Z",
            "endTime": "2022-09-06T04:00:00Z",
            "groups": [],
            "value": 427.22727272727275,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-06T04:00:00Z",
            "endTime": "2022-09-07T04:00:00Z",
            "groups": [],
            "value": 857.8656716417911,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-07T04:00:00Z",
            "endTime": "2022-09-08T04:00:00Z",
            "groups": [],
            "value": 1043.3389830508474,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-08T04:00:00Z",
            "endTime": "2022-09-09T04:00:00Z",
            "groups": [],
            "value": 281.1896551724138,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-09T04:00:00Z",
            "endTime": "2022-09-10T04:00:00Z",
            "groups": [],
            "value": 453.78125,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-10T04:00:00Z",
            "endTime": "2022-09-11T04:00:00Z",
            "groups": [],
            "value": 4273,
            "isPartialPeriod": false
          },
          {
            "startTime": "2022-09-11T04:00:00Z",
            "endTime": "2022-09-12T04:00:00Z",
            "groups": [],
            "value": 674.0769230769231,
            "isPartialPeriod": false
          }
        ],
        "numGroups": "0"
      }
    },
    "direction": 1,
    "periodicStats": [
      {
        "startDate": "2022-08-15T04:00:00Z",
        "endDate": "2022-08-22T04:00:00Z",
        "variability": { "stdUpper": "NaN", "stdLower": "NaN" }
      },
      {
        "startDate": "2022-08-22T04:00:00Z",
        "endDate": "2022-08-29T04:00:00Z",
        "variability": { "stdUpper": 1550.629042659606, "stdLower": 220.8330383003697 }
      },
      {
        "startDate": "2022-08-29T04:00:00Z",
        "endDate": "2022-09-05T04:00:00Z",
        "variability": { "stdUpper": 1211.1386510345264, "stdLower": 65.75859470690614 }
      },
      {
        "startDate": "2022-09-05T04:00:00Z",
        "endDate": "2022-09-12T04:00:00Z",
        "variability": { "stdUpper": 2444.798134946749, "stdLower": -156.08963332696453 }
      }
    ],
    "ratioChange": 1.9558547023360582
  }
}
